export const RESULTS_HEADING_ID = 'results-heading';
